import { FarmListResponse } from "./typings";
import * as _ from "lodash";

/**
 * Assigns obfuscated names to an array of farm entities.
 * @param {Omit<FarmEntity, "obfuscatedName">[]} farms
 * @returns {FarmEntity[]}
 */
export const assignObfuscatedNames = (farms: FarmListResponse["farms"]): FarmListResponse["farms"] => {
  return _.map(_.sortBy(farms, "name"), (farm, idx) => {
    return {
      ...farm,
      obfuscatedName: `Farm ${idx + 1}`
    };
  });
};
